export default __webpack_public_path__ + "static/media/foodHub.5326ec61.png";